import { IClientThreadEntry } from "@cosine/types/api-models";
import { faker } from "@faker-js/faker/locale/en_US";

export function createThreadMessage (overrides: Partial<IClientThreadEntry> = {}): IClientThreadEntry {
  return {
    ThreadId: faker.string.uuid(),
    Reactions: [],
    Text: faker.lorem.sentence(),
    Source: "User",
    Attachments: [],
    DateCreated: faker.date.past(),
    DateUpdated: faker.date.past(),
    DateDeleted: undefined,
    IdReference: faker.string.uuid(),
    ...overrides,
  };
}
